import * as React from "react";
import {
  Checkbox,
  createStyles,
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Theme,
} from "@material-ui/core";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import { Skeleton } from "@material-ui/lab";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      "height": "100%",

      "& .MuiTableRow-root:nth-child(odd)": {
        background: theme.customPaper.background.cardBackgroundTable,
      },

      "& .MuiTableCell-alignCenter": {
        color: theme.palette.text.secondary,
      },
    },
  })
);

/* eslint-disable @typescript-eslint/no-explicit-any*/
type SimpleTableProps = {
  removeCheckBox?: boolean;
  handleSelect?: (row?: any, row2?: any) => any;
  onClickRemoveAll?: () => any;
  areAllSelected?: boolean;
  header: string[];
  selectedRows?: any[];
  desableClick?: boolean;
  rows: any[][];
  loading?: boolean;
  hasId?: boolean;
};
/* eslint-enable @typescript-eslint/no-explicit-any*/

const loadingState = new Array(12).fill({});

function InstallationTable({
  removeCheckBox = false,
  desableClick = false,
  selectedRows,
  handleSelect,
  onClickRemoveAll,
  areAllSelected,
  header,
  rows,
  loading = false,
  hasId,
}: SimpleTableProps) {
  const classes = useStyles();

  const ascending = (a: [], b: [], ref: any): any => (a[ref] > b[ref] ? 1 : -1);
  const descending = (a: [], b: [], ref: any): any => (a[ref] > b[ref] ? -1 : 1);

  const [columnClicked, setColumnClicked] = React.useState();
  const [isReverse, setIsReverse] = React.useState(false);

  const onclick = (idx: any) => {
    if (idx === columnClicked) {
      setIsReverse(!isReverse);
    } else {
      setColumnClicked(idx);
      setIsReverse(false);
    }
  };

  const sort = (a: any, b: any, ref: any) => {
    return isReverse ? descending(a, b, ref) : ascending(a, b, ref);
  };

  return (
    <TableContainer className={classes.root} component={Paper}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            {removeCheckBox && (
              <TableCell align="center" padding="checkbox">
                {" "}
                <Checkbox checked={areAllSelected} onClick={onClickRemoveAll} />{" "}
              </TableCell>
            )}
            {header.map(
              (h, idx) =>
                h != "" && (
                  <TableCell
                    onClick={() => !desableClick && onclick(idx)}
                    align="center"
                    key={`header_${idx}`}
                  >
                    <strong>{h}</strong>
                    {columnClicked === idx && isReverse && <ArrowDropDownIcon color="primary" />}
                    {columnClicked === idx && !isReverse && <ArrowDropUpIcon color="primary" />}
                  </TableCell>
                )
            )}
          </TableRow>
        </TableHead>

        <TableBody>
          {!loading &&
            (columnClicked !== undefined
              ? rows
                  .sort((a, b) => sort(a, b, columnClicked))
                  .map((row, idx) => {
                    return (
                      <TableRow key={`row_${idx}`}>
                        {removeCheckBox && (
                          <TableCell align="center" padding="checkbox">
                            <Checkbox
                              checked={
                                selectedRows &&
                                (hasId ? selectedRows.includes(row) : selectedRows.includes(row[0]))
                              }
                              onClick={() =>
                                handleSelect && (hasId ? handleSelect(row) : handleSelect(row[0]))
                              }
                            />
                          </TableCell>
                        )}
                        {row.map((cell, idy) => (
                          <TableCell align="center" key={`row_${idx}_col_${idy}`}>
                            {cell}
                          </TableCell>
                        ))}
                      </TableRow>
                    );
                  })
              : rows.map((row, idx) => (
                  <TableRow key={`row_${idx}`}>
                    {removeCheckBox && (
                      <TableCell align="center" padding="checkbox">
                        <Checkbox
                          checked={
                            selectedRows &&
                            (hasId ? selectedRows.includes(row) : selectedRows.includes(row[0]))
                          }
                          onClick={() =>
                            handleSelect && (hasId ? handleSelect(row) : handleSelect(row[0]))
                          }
                        />
                      </TableCell>
                    )}
                    {row.map((cell, idy) => {
                      if (hasId) {
                        if (idy !== 0)
                          return (
                            <TableCell align="center" key={`row_${idx}_col_${idy}`}>
                              {cell}
                            </TableCell>
                          );
                      } else {
                        return (
                          <TableCell align="center" key={`row_${idx}_col_${idy}`}>
                            {cell}
                          </TableCell>
                        );
                      }
                    })}
                  </TableRow>
                )))}
          {loading &&
            loadingState.map((_, idx) => (
              <TableRow key={`loading_row_${idx}`}>
                <TableCell colSpan={header.length}>
                  <Skeleton />
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default InstallationTable;
